import isSameDay from 'date-fns/is_same_day';
const isSameDayAsExcluded = excludedDate => date => isSameDay(excludedDate, date);
export default isSameDayAsExcluded;
//# sourceMappingURL=isSameDayAsExcluded.js.map